import { API_CONFIG } from '../lib/apiConfig';
import { createPngMetaOverlayHook } from '../lib/hookFactories';

/**
 * Resolves the precomputed AGB change PNG + bounds for the supply shed.
 *
 * The PNG is a categorical diverging 5-bin raster (smoothed-endpoint
 * difference: mean 2021-25 minus mean 2000-04, per 100 m pixel). Used by
 * the redesigned Carbon Offense scenario when a step's
 * `overlayVariants.aboveground_biomass === 'change'` — the year-tile
 * crossfade is suppressed in that mode so the two AGB renderings never
 * stack.
 *
 * 404-tolerant by virtue of the underlying factory: when the precompute
 * hasn't been run for a (mill, dt) pair the meta fetch fails and the hook
 * surfaces an error string. The caller decides how to render that.
 */
export const useAgbChangeOverlay = createPngMetaOverlayHook({
  metaPath: API_CONFIG.s3.paths.agbChangeOverlayMeta,
  pngPath: API_CONFIG.s3.paths.agbChangeOverlay,
});
